import AttentionPop from './attentionPop.vue'

const attentionPop = {
  install (Vue) {
    if (typeof window !== 'undefined' && window.Vue) {
      Vue = window.Vue
    }
    Vue.component('attentionPop', AttentionPop)

    function isShowAttentionPop (type,url,isCanClose) {
      let VueAttentionPop = Vue.extend({
        render (h) {
          let props = {
            show: this.show,
            canClose : this.canClose,
            erweimaUrl : this.erweimaUrl
          }
          return h('attentionPop', {
            props
          })
        },
        data () {
          return {
            show: type != 'close' ? true : false,
            canClose :isCanClose == 'canClose' ? true : false,
            erweimaUrl:url? url : ''
          }
        }
      })
      let newAttentionPop = new VueAttentionPop()
      let vm = newAttentionPop.$mount()
      let el = vm.$el
      document.body.appendChild(el) // 把生成的提示的dom插入body中
    }
    // 挂载到vue原型上，暴露方法
    Vue.prototype.$attentionPop = {
      open (erweimaUrl,type) {
        isShowAttentionPop('open', erweimaUrl,type)
      },
      canClose () {
        isShowAttentionPop('canClose')
      }
    }
  }
}
export default attentionPop



// WEBPACK FOOTER //
// ./src/components/attentionPop/index.js